export default "__VITE_ASSET__CUH6Hsfq__"